import { call, put, takeEvery } from 'redux-saga/effects'
import { getPaymentMethods } from 'services/api/payments'

import {
  FetchPaymentMethodsActionType,
  setPaymentMethods,
  setPaymentMethodsError,
  setPaymentMethodsLoading
} from './actions'
import * as actionTypes from './actionTypes'

const fetchPaymentMethods = function* (action: FetchPaymentMethodsActionType) {
  const {
    payload: { currency }
  } = action
  yield put(setPaymentMethods(currency, []))
  yield put(setPaymentMethodsLoading(currency, true))
  const data = yield call(getPaymentMethods, currency)

  if (data.error) return yield put(setPaymentMethodsError(currency, data.error))

  yield put(setPaymentMethods(currency, data.response.methods))
  yield put(setPaymentMethodsLoading(currency, false))
}

export default function* methodsSagas() {
  yield takeEvery(actionTypes.FETCH_PAYMENT_METHODS_TYPE, fetchPaymentMethods)
}
